/* eslint-disable no-underscore-dangle */
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { whenSideBySide, assignFormDesignToCSSVars } from '../fields-customise.style';
import SpecialPropsIndicators from '../props-Indicator/special-props';
import { FormContext } from '../../../shared/contexts/form-context';
import { ctrlDefaults } from '../../../../shared/form-lib';
import FlutterwaveSubComponent from './flutterwave-sub';
import { selectCtrlIdLabelMap } from '../../selectors';
import {
  ValidationWarning,
  MainfieldWrapper,
  SubtextWrapper,
  FieldWrapper,
  LabelWrapper,
  InputWrapper,
  Field,
} from '../../common-field-styles';

const Flutterwave = ({ ctrl, formDesign, isRenderedOnModal }) => {
  const { isPayOnSubmission } = useSelector((state) => state.form);
  const ctrlIdLabelMap = useSelector(selectCtrlIdLabelMap);
  const fieldLabel = ctrlIdLabelMap?.[ctrl.internal_id];
  const { inBuilder } = useContext(FormContext);

  return (
    <MainfieldWrapper tabIndex="0" style={assignFormDesignToCSSVars(inBuilder, formDesign)}>
      <FieldWrapper>
        {ctrl._validationError && (
           <ValidationWarning className="ui bottom pointing basic label red">{ctrl._validationError}</ValidationWarning>
        )}

        <Field className={!inBuilder ? whenSideBySide(ctrl, formDesign) : ''}>
          {!ctrl.props.is_inventory_payment && !isPayOnSubmission && (
            <LabelWrapper
              className={!inBuilder ? whenSideBySide(ctrl, formDesign) : ''}
              required={ctrl.props.required}
              notInBuilder={!inBuilder}>
              <label dangerouslySetInnerHTML={{ __html: fieldLabel || ctrlDefaults()[ctrl.type] }} />
              <SpecialPropsIndicators ctrl={ctrl} />
            </LabelWrapper>
          )}

          <InputWrapper className={!inBuilder ? whenSideBySide(ctrl, formDesign) : ''}>
            <FlutterwaveSubComponent ctrl={ctrl} formDesign={formDesign} isRenderedOnModal={isRenderedOnModal} />
            
            <SubtextWrapper id="descriptive text" notInBuilder={!inBuilder}>
              {ctrl.props.subtext}
            </SubtextWrapper>
          </InputWrapper>
        </Field>
      </FieldWrapper>
    </MainfieldWrapper>
  );
};

Flutterwave.defaultProps = {
  isRenderedOnModal: false,
  formDesign: null,
};

Flutterwave.propTypes = {
  isRenderedOnModal: PropTypes.bool,
  ctrl: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  formDesign: PropTypes.shape({
    old: PropTypes.object.isRequired,
    design: PropTypes.object.isRequired,
  }),
};

export default Flutterwave;
